// extracted by mini-css-extract-plugin
export default {"container":"Ready_container__kB1+N","btn":"Ready_btn__i7c+7"};